import { render, staticRenderFns } from "./chatMessages.vue?vue&type=template&id=41b78eb4&scoped=true&"
import script from "./chatMessages.vue?vue&type=script&lang=js&"
export * from "./chatMessages.vue?vue&type=script&lang=js&"
import style0 from "./chatMessages.vue?vue&type=style&index=0&id=41b78eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b78eb4",
  null
  
)

export default component.exports